import { produce } from 'immer';

import type { CREDIT_PROFILE_REDUCER_KEY } from 'app-components/flux/credit-profile/types';
import createForm, { ValidationTrigger } from 'app-components/utils/createForm/createForm';
import type RootState from 'app-components/utils/redux-store/rootState';

import { getHyphenatedSSNValue } from './utils';

type State = {
  ssn: string;
};

export type FieldValues = {
  ssn: string;
};

// @ts-expect-error FIXME TS7006
const reducer = (state, action) =>
  // @ts-expect-error FIXME TS7006
  produce(state, (draft) => {
    switch (action.t) {
      case 'valueChange':
        switch (action.field) {
          case 'ssn':
            draft.ssn = getHyphenatedSSNValue(action.value);
            break;
        }
    }
  });

const init = (input: State) => input;

const updateCreditReport = createForm({
  types: {} as {
    fieldValues: FieldValues;
    reduxStore: Pick<RootState, typeof CREDIT_PROFILE_REDUCER_KEY>;
  },
  reducer,
  init,
  fieldConfigs: {
    ssn: {
      selector: ({ ssn }) => ssn,
      validation: {
        required: {
          triggers: ValidationTrigger.onSubmit,
          validate: ({ ssn }) => (!ssn ? 'SSN is required' : undefined),
        },
        length: {
          triggers: ValidationTrigger.onSubmit,
          validate: ({ ssn }) => (ssn.replaceAll?.('-', '').length !== 9 ? 'Enter a valid SSN number' : undefined),
        },
      },
    },
  },
  submitTransformer: (state) => state,
});

export const {
  Provider: CreditReportUpdateProvider,
  useFormField,
  ...updateCreditReportHooks
} = updateCreditReport.createManagerProvider();
